export const endpoints = {
  RESET_PASSWORD: '/api/c0/execute/WebEnvironment/ResetPasswordForAll',
};
